import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-profile-pic-modal',
  templateUrl: './change-profile-pic-modal.component.html',
  styleUrls: ['./change-profile-pic-modal.component.scss']
})
export class ChangeProfilePicModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
